<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#detail4_1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES33UC12']['0'] }}
          </h3>
        </div>
        <div id="detail4_1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail-block">
              <div class="row">

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC12']['100'] }}</label>
                    <input type="text" id="coddesc_codinput" name="coddesc_codinput" class="form-control" readonly="readonly" v-model="descCodinput" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC12']['10'] }}</label>
                    <input type="text" id="coddesc_codempid" name="coddesc_codempid" class="form-control" readonly="readonly" v-model="descCodempid" />
                  </div>
                </div>

                <div class="col-xs-12 col-ms-6 col-sm-4 col-md-4">
                  <div class="form-group">
                    <label>{{ labels['HRES33UC12']['20'] }}</label>
                    <input type="text" id="dtereq" name="dtereq" class="form-control" readonly="readonly" :value="setDateOutput(detail.detail.dtereq)" />
                  </div>
                </div>
              
              </div>
            </div>

            <div class="detail-header">{{ labels['HRES33UC12']['30'] }}</div>
            <hrms-table :columns="tab4Table1" :data="detail.table1" />

            <div class="detail-block"></div>

            <div class="detail-header">{{ labels['HRES33UC12']['80'] }}</div>
            <hrms-table :columns="tab4Table2" :data="detail.table2" />
            
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ buttonLabels['back'] }}</button>
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres33u-detail4',
  watch: {
    'detail' () {
      this.detail.table1.rows = this.detail.table1.rows.filter((dataRow) => {
        return dataRow.flgchange === 'n'
      })
      this.detail.table1.total = this.detail.table1.rows.length
      this.detail.table2.rows = this.detail.table2.rows.filter((dataRow) => {
        return dataRow.flgchange === 'o'
      })
      this.detail.table2.total = this.detail.table2.rows.length
    }
  },
  props: [ 'labels', 'detail', 'toggle', 'data', 'nowLang', 'tab4Table1', 'tab4Table2', 'buttonLabels' ],
  computed: {
    descCodinput () {
      return this.detail.detail.codinput + ' - ' + this.detail.detail.desc_codinput
    },
    descCodempid () {
      return this.detail.detail.codempid + ' - ' + this.detail.detail.desc_codempid
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail4.vue?4ba745fe